"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssetRegistry_1 = require("./core/AssetRegistry");
exports.arrowLeftWhiteIcon = AssetRegistry_1.default.get('arrow-left-white');
exports.arrowRightWhiteIcon = AssetRegistry_1.default.get('arrow-right-white');
exports.arrowheadDownIcon = AssetRegistry_1.default.get('arrowhead-down');
exports.arrowheadDownWhiteIcon = AssetRegistry_1.default.get('arrowhead-down-white');
exports.arrowheadRightIcon = AssetRegistry_1.default.get('arrowhead-right');
exports.arrowLeftIcon = AssetRegistry_1.default.get('arrow-left');
exports.arrowLeftInactiveIcon = AssetRegistry_1.default.get('arrow-left-inactive');
exports.arrowRightIcon = AssetRegistry_1.default.get('arrow-right');
exports.arrowRightInactiveIcon = AssetRegistry_1.default.get('arrow-right-inactive');
exports.playIcon = AssetRegistry_1.default.get('play');
exports.starYellowIcon = AssetRegistry_1.default.get('star-yellow');
exports.starEmptyIcon = AssetRegistry_1.default.get('star-empty');
exports.searchBigIcon = AssetRegistry_1.default.get('search-big');
exports.searchIcon = AssetRegistry_1.default.get('search');
exports.hamburgerIcon = AssetRegistry_1.default.get('hamburger');
exports.closeIcon = AssetRegistry_1.default.get('close');
exports.closeWhiteIcon = AssetRegistry_1.default.get('close-white');
exports.closeWhiteSmallIcon = AssetRegistry_1.default.get('close-white-small');
exports.exclamationIcon = AssetRegistry_1.default.get('exclamation');
exports.profileIcon = AssetRegistry_1.default.get('profile');
exports.closeBlackIcon = AssetRegistry_1.default.get('e-remove');
exports.eventTicketIcon = AssetRegistry_1.default.get('event-ticket');
exports.frameCArrowRight = AssetRegistry_1.default.get('frame-c-arrow-right');



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-asset-provider/icons.ts